import React, { ComponentType, FunctionComponent, ReactElement } from 'react';
import { useTheme } from 'react-jss';

import { Box } from '@wds/box';
import { Theme } from '@wds/styles';

import { TabletScreen, MobileScreen } from '../../../MediaComponents';
import MomentiveLogoType from './MomentiveLogoType';
import MomentiveLogoMark from './MomentiveLogoMark';
import useStyles from './useStyles';

type PropsWithHeader = {
  isContrast: boolean;
  isUserAuthenticated: boolean;
};
function withHeaderLink(
  Component: ComponentType<PropsWithHeader>
): FunctionComponent<PropsWithHeader> {
  return (props: PropsWithHeader): ReactElement => {
    const { isUserAuthenticated } = props;
    const theme: Theme = useTheme();
    const classes = useStyles({ isUserAuthenticated, theme });
    return (
      <Box className={classes.headerBox} display="flex" flexAlign="center">
        <a href="/" aria-label="Momentive Logo" className={classes.headerLink}>
          <Box className={classes.headerLogo} display="flex" flexAlign="center">
            <Component {...props} />
          </Box>
        </a>
      </Box>
    );
  };
}

type PropsWithIcons = {
  isContrast: boolean;
  showTypography?: boolean;
};
const MomentiveIcons = ({
  isContrast,
  showTypography = false,
}: PropsWithIcons): ReactElement => {
  const theme: Theme = useTheme();
  const typeColor = isContrast
    ? theme.palette.text.dark
    : theme.palette.text.light;
  return (
    <Box display="flex" flexDirection="row">
      {showTypography && (
        <Box display="flex" pr={1} flexAlign="flex-end">
          <MomentiveLogoType fill={typeColor} />
        </Box>
      )}
      <Box display="flex" flexAlign="flex-end">
        <MomentiveLogoMark />
      </Box>
    </Box>
  );
};
const MomentiveLogo = ({
  isUserAuthenticated,
  isContrast,
}: PropsWithHeader): ReactElement => {
  if (!isUserAuthenticated) {
    return (
      <>
        <TabletScreen>
          <MomentiveIcons isContrast={isContrast} showTypography />
        </TabletScreen>
        <MobileScreen>
          <MomentiveIcons isContrast={isContrast} />
        </MobileScreen>
      </>
    );
  }

  return <MomentiveIcons isContrast={isContrast} showTypography />;
};
export default withHeaderLink(MomentiveLogo);
